import { Injectable } from '@angular/core';
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from '@angular/common/http';
import { Observable } from 'rxjs';
import { finalize, tap } from 'rxjs/operators';

// Mapa para armazenar requisições em voo e reaproveitar o observable
const inFlight = new Map<string, Observable<HttpEvent<any>>>();

@Injectable()
export class DedupeEtagInterceptor implements HttpInterceptor {
  intercept(
    req: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Bloqueia requisições GET para URLs com id=null ou id=undefined
    if (
      req.method === 'GET' &&
      req.url.includes('?') &&
      /id=(null|undefined|)$/.test(req.url)
    ) {
      // Retorna um observable vazio que completa imediatamente
      return new Observable<HttpEvent<any>>(subscriber =>
        subscriber.complete()
      );
    }

    const cacheKey = req.method + '::' + req.urlWithParams;

    // Se já existe uma requisição em voo com a mesma chave, reaproveita o observable
    if (inFlight.has(cacheKey)) {
      return inFlight.get(cacheKey);
    }

    // Anexa If-None-Match quando temos ETag armazenado
    const stored = localStorage.getItem('etag:' + req.urlWithParams);
    const modifiedReq = stored
      ? req.clone({ setHeaders: { 'If-None-Match': stored } })
      : req;

    const obs$ = next.handle(modifiedReq).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          const etag = event.headers.get('ETag') || event.headers.get('etag');
          if (etag) {
            try {
              localStorage.setItem('etag:' + req.urlWithParams, etag);
            } catch (e) {
              // ignora erros de storage (por ex. quotas)
            }
          }
        }
      }),
      finalize(() => {
        inFlight.delete(cacheKey);
      })
    );

    inFlight.set(cacheKey, obs$);
    return obs$;
  }
}
